var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animation-container"},[_c('transition',{attrs:{"appear":"","name":("slide-" + _vm.direction)}},[_c('div',{staticStyle:{"position":"relative"},style:({ transitionDelay: (_vm.delay + "ms") })},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }